import { ReactNode } from 'react';

type VisibleProps = {
  when: boolean;
  children: ReactNode;
};

const Visible = ({ when, children }: VisibleProps) => {
    if (!when) {
        return null;
    }

  return <div> {children} </div>;
};

export { Visible };
